// src/components/FeatureAndServiceTabs.js
import { useEffect, useState } from 'react'; // Import React and useEffect
import { FaGraduationCap, FaHandsHelping, FaHeart, FaLaptopCode, FaSchool, FaUserGraduate } from 'react-icons/fa';
import servicesData from '../data/servicesData';
import BenefitCard from './BenefitCard';
import ServiceCard from './ServiceCard'; // Corrected typo: ServiceCard

// --- CORRECTED IMPORTS ---
import aboutusStyles from '../styles/aboutus.module.css'; // For toggleBtn (this is a CSS Module)
// IMPORTANT: For global.css, import it directly without assigning to a variable.
// This makes its styles globally available to all components that import it (or a parent).
import '../styles/global.css'; // For imageFrame, glassFrame, and other global styles (this is global CSS)
// -------------------------

// --- IMPORTS FOR CLASSROOM PHOTOS ---
import classroom1Photo from '../assets/classroom1.jpg';
import classroom2Photo from '../assets/classroom2.jpg';
// Assuming you'll add classroom3.jpg, classroom4.jpg, classroom5.jpg to your assets folder
// For now, using placeholders to avoid compilation errors
import classroom3Photo from '../assets/classroomLook.jpeg';
// import classroom4Photo from '../assets/classroom4.jpg';
// import classroom5Photo from '../assets/classroom5.jpg';
// ------------------------------------

// New component for the Classroom Carousel Section
function ClassroomCarousel() {
  const carouselPhotos = [
    { src: classroom1Photo, title: 'Modern Classroom', description: 'Designed for interactive and engaging Japanese language learning.' },
    { src: classroom2Photo, title: 'Spacious Learning Environment', description: 'Comfortable and conducive spaces for every student to thrive.' },
    { src: classroom3Photo, title: 'Academy Interior & Classrooms', description: 'A welcoming view of our modern academy, leading to dedicated learning spaces.' },
    //{ src: 'https://placehold.co/600x350/ADD8E6/333333?text=Library+Corner', title: 'Resourceful Library Corner', description: 'Extensive collection of Japanese learning materials and resources.' },
    //{ src: 'https://placehold.co/600x350/90EE90/333333?text=Student+Lounge', title: 'Vibrant Student Lounge', description: 'A relaxing space for students to socialize and practice Japanese.' },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalTime = 3000; // 3 seconds for auto-swap

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselPhotos.length);
    }, intervalTime);

    // Cleanup the interval on component unmount
    return () => clearInterval(timer);
  }, [carouselPhotos.length, intervalTime]); // Re-run effect if photos length or interval changes

  const goToPrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? carouselPhotos.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselPhotos.length);
  };

  return (
    <div className="col-12 mt-5">
      <h3 className="text-center mb-4 fw-bold" style={{ color: 'var(--primary-brand-dark)' }}>
        Our Learning Environment
      </h3>
      <p className="text-center mb-5 text-muted">Explore our modern and comfortable classrooms designed for effective Japanese language education.</p>

      <div className="carousel-container">
        <div
          className="carousel-slide"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {carouselPhotos.map((photo, idx) => (
            <div key={idx} className="carousel-image-wrapper">
              <img
                src={photo.src}
                alt={photo.title}
                className="carousel-image"
                loading="lazy"
              />
              <div className="carousel-text-overlay">
                <h4>{photo.title}</h4>
                <p>{photo.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Buttons */}
        <button className="carousel-button prev" onClick={goToPrev} aria-label="Previous slide">
          &#10094; {/* Left arrow character */}
        </button>
        <button className="carousel-button next" onClick={goToNext} aria-label="Next slide">
          &#10095; {/* Right arrow character */}
        </button>

        {/* Indicators */}
        <div className="carousel-indicators">
          {carouselPhotos.map((_, idx) => (
            <span
              key={idx}
              className={`indicator-dot ${idx === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(idx)}
              aria-label={`Go to slide ${idx + 1}`}
            ></span>
          ))}
        </div>
      </div>
    </div>
  );
}


function FeatureAndServiceTabs() {
  const [key, setKey] = useState('whyChooseUs');

  const benefitData = [
    { icon: <FaHandsHelping size={40} color="var(--primary-brand-dark)" />, title: 'Emergency Support', description: 'Staff in Japan ready to assist you anytime.' },
    { icon: <FaUserGraduate size={40} color="var(--primary-brand-dark)" />, title: 'Japan-Focused', description: 'We specialize solely in Japan education.' },
    { icon: <FaHeart size={40} color="var(--primary-brand-dark)" />, title: 'Mission Driven', description: 'Our goal is to empower Nepali students, not profit.' },
    { icon: <FaLaptopCode size={40} color="var(--primary-brand-dark)" />, title: 'Specialized Fields', description: 'IT, Architecture, AI & more for your bright future.' },
    { icon: <FaSchool size={40} color="var(--primary-brand-dark)" />, title: 'Real-Life Training', description: 'Simulate Japanese lifestyle before going abroad.' },
    { icon: <FaGraduationCap size={40} color="var(--primary-brand-dark)" />, title: '10+ Years in Japan', description: 'Learn directly from returnee professionals.' },
  ];

  return (
    <section
      id="features-services"
      className="py-5"
      style={{ background: 'var(--section-bg-light)' }} /* Ensure this applies the gradient */
    >
      <div className="container">
        <h2
          className="text-center mb-5 fw-bold"
          style={{
            color: 'var(--primary-brand-dark)',
            marginTop: '50px',
          }}
        >
          What We Offer
        </h2>

        {/* Custom Tab Buttons */}
        <div className="d-flex justify-content-center mb-5 gap-3">
          <button
            onClick={() => setKey('whyChooseUs')}
            className={`${aboutusStyles.toggleBtn} ${key === 'whyChooseUs' ? aboutusStyles.active : ''}`}
            aria-label="Show Why Choose Us content"
          >
            Why Choose Us?
          </button>
          <button
            onClick={() => setKey('ourServices')}
            className={`${aboutusStyles.toggleBtn} ${key === 'ourServices' ? aboutusStyles.active : ''}`}
            aria-label="Show Our Services content"
          >
            Our Services
          </button>
        </div>

        {/* Conditional Content Rendering */}
        <div className="tab-content py-4" style={{ backgroundColor: 'transparent' }}>
          {key === 'whyChooseUs' && (
            <div className="row text-center g-4">
              {benefitData.map((benefit, idx) => (
                <BenefitCard key={idx} {...benefit} />
              ))}
              {/* Render Classroom Carousel here */}
              <ClassroomCarousel />
            </div>
          )}

          {key === 'ourServices' && (
            <div className="row text-center g-4">
              {/* Existing Service Cards */}
              {servicesData.map((service, idx) => (
                <ServiceCard key={idx} {...service} />
              ))}
              {/* Render Classroom Carousel here */}
              <ClassroomCarousel />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default FeatureAndServiceTabs;
